<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <hr>
    <h6
      class="d-flex justify-content-center"
      :style="`color: rgba(${InfoData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255'}, 1.0);`"
    >
      <span>{{ $t('activity.activity-rules') }}</span>
    </h6>
    <div
      class="text-left w-100 text-break-all"
      style="min-height:20vh"
      v-html="InfoData.introductionDesc"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
    // 活動資料
      activity: { scratchOffInfo: {}, slotInfo: {}, rouletteInfo: {} },
      InfoData: { titleColor: '', introductionDesc: '', transparentMask: '' },
    };
  },
  created() {
    const vm = this;

    // 取得活動資料
    vm.$store.dispatch('getActivity').then(
      (activity) => {
        vm.activity = activity;
        switch (activity.categoryID) {
          case 'Scratchoff':
            vm.InfoData.titleColor = activity.scratchOffInfo.titleColor;
            vm.InfoData.introductionDesc = activity.scratchOffInfo.introductionDesc;
            vm.InfoData.transparentMask = activity.scratchOffInfo.transparentMask;
            break;
          case 'Slot':
            vm.InfoData.titleColor = activity.slotInfo.titleColor;
            vm.InfoData.introductionDesc = activity.slotInfo.introductionDesc;
            vm.InfoData.transparentMask = activity.slotInfo.transparentMask;
            break;
          case 'Roulette':
            vm.InfoData.titleColor = activity.rouletteInfo.titleColor;
            vm.InfoData.introductionDesc = activity.rouletteInfo.introductionDesc;
            vm.InfoData.transparentMask = activity.rouletteInfo.transparentMask;
            break;
          default:
            break;
        }
      },
    );
  },
};
</script>
